<template>
    <div class="flex items-center pb-3">
        <div
            class="w-full border-t border-divider"
            aria-hidden="true"
        />
        <div class="relative flex justify-center">
            <slot />
        </div>
        <div
            class="w-full border-t border-divider"
            aria-hidden="true"
        />
    </div>
</template>
